import React, { Component } from 'react';
import { Form } from 'react-final-form';
import { isEmail, isRequired } from '../../../utils/validation';
import TextField from '../../../components/Form/TextField';
import EmailField from '../../../components/Form/EmailField';
import AddressFormSection from '../../../components/Form/AddressFormSection';
import { getListNations } from '../../../api/nations';
import { getListMunicipalities } from '../../../api/municipalities';
import { updateAgency } from '../../../api/users';
import Loader from '../../../atoms/Loader';

class Edit extends Component {
  state = {
    loading: true,
    error: null,
    nations: [],
    municipalities: [],
    isDataReady: false,
    agency: null,
  };

  async componentDidMount() {
    try {
      const [nationsList, municipalitiesList] = await Promise.all([
        getListNations(),
        getListMunicipalities(),
      ]);

      const nations = nationsList.map(({ code, name }) => ({
        value: code.toString(),
        label: name,
      }));

      const municipalities = municipalitiesList?.map(({ oldId, name, provincia }) => ({
        value: oldId.toString(),
        label: `${name} (${provincia})`,
        oldId,
      }));

      const { agency } = this.props;
      if (agency?.indirizzo) {
        if (agency.indirizzo.nazione === 'IT' && agency.indirizzo.citta) {
          agency.indirizzo.citta = agency.indirizzo.citta.toString();
          agency.indirizzo.cittaNome = null;
        } else {
          agency.indirizzo.citta = null;
          agency.indirizzo.cittaNome = agency.indirizzo.cittaNome || '';
        }
      }

      this.setState({
        nations,
        municipalities,
        loading: false,
        isDataReady: true,
        agency,
      });
    } catch (e) {
      console.error(e);
      this.setState({ loading: false });
    }
  }

  handleSubmit = async (data) => {
    const { id, checkRole } = this.props;

    this.setState({ loading: true });

    try {
      const submissionData = {
        ...data,
        username: data.email,
        indirizzo: {
          ...data.indirizzo,
          citta: data.indirizzo.nazione === 'IT'
            ? (data.indirizzo.citta ? parseInt(data.indirizzo.citta, 10) : null)
            : null,
          cittaNome: data.indirizzo.nazione !== 'IT'
            ? (data.indirizzo.cittaNome || '')
            : null,
        },
      };

      await updateAgency(id, submissionData);
      checkRole(data);
      this.setState({
        agency: data,
        error: null,
      });
    } catch (e) {
      const error = typeof e.request !== 'undefined'
        ? JSON.parse(e.request.response)
        : e.getMessage;
      this.setState({ error });
    } finally {
      this.setState({ loading: false });
    }
  };

  render() {
    const {
      error, nations, municipalities, isDataReady,
    } = this.state;
    const { agency } = this.props;

    if (!isDataReady) {
      return <Loader />;
    }

    return (
      <Form
        onSubmit={this.handleSubmit}
        initialValues={agency}
        render={({
          handleSubmit, submitting, pristine, values,
        }) => (
          <>
            <div className="columns">
              <div className="column is-one-third">
                <TextField
                  name="ragioneSociale"
                  placeholder="es. Company srl"
                  validate={isRequired}
                  label="Ragione Sociale"
                  errors={error?.ragioneSociale}
                />
              </div>
            </div>

            <div className="columns">
              <div className="column is-one-third">
                <EmailField
                  name="email"
                  placeholder="es. info@company.net"
                  validate={isEmail}
                  label="Email"
                  errors={error?.email}
                />
              </div>
              <div className="column is-one-third">
                <EmailField
                  name="pec"
                  placeholder="es. company@pec.it"
                  label="PEC"
                  errors={error?.pec}
                />
              </div>
              <div className="column is-one-third">
                <TextField
                  name="sdi"
                  placeholder="Codice SDI"
                  label="Codice SDI"
                  errors={error?.sdi}
                />
              </div>
            </div>

            <div className="columns">
              <div className="column is-one-third">
                <TextField
                  name="pIva"
                  placeholder="es. IT01234567890"
                  label="Partita IVA"
                  errors={error?.pIva}
                />
              </div>
              <div className="column is-one-third">
                <TextField
                  name="codiceFiscale"
                  placeholder="Codice Fiscale"
                  label="Codice Fiscale"
                  errors={error?.codiceFiscale}
                />
              </div>
              <div className="column is-one-third">
                <TextField
                  name="alsiria"
                  placeholder="PCLI"
                  label="PCLI"
                  errors={error?.alsiria}
                />
              </div>
            </div>

            <div className="columns">
              <div className="column">
                <AddressFormSection
                  nations={nations}
                  municipalities={municipalities}
                  values={values}
                />
              </div>
            </div>

            <footer>
              <div className="field">
                <div className="control">
                  <button
                    type="submit"
                    onClick={handleSubmit}
                    className="button is-orange is-large"
                    disabled={submitting || pristine}
                  >
                    Modifica
                  </button>
                </div>
              </div>
            </footer>
          </>
        )}
      />
    );
  }
}

export default Edit;
